"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _reactReduxI18n = require("react-redux-i18n");

var _reactRouterDom = require("react-router-dom");

var _jsxRuntime = require("react/jsx-runtime");

function Tab(_ref) {
  var label = _ref.label,
      link = _ref.link;

  function renderLabel() {
    if (typeof label === 'string') {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "m-0",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
          value: label
        })
      });
    }

    return label;
  }

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Tab, {
    "data-id": "tab-".concat(label),
    value: link,
    to: link,
    component: _reactRouterDom.Link,
    label: renderLabel()
  }, "tab-".concat(link));
}

Tab.propTypes = {
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  link: _propTypes.default.string.isRequired
};
var _default = Tab;
exports.default = _default;
//# sourceMappingURL=Tab.js.map